import { Moment } from 'moment';
import { apiGet, API_URI } from './index';

const heatmap = {
    getAll: async (projectId: number, dateFrom: Moment, dateTo: Moment, streamIds: number[]) => {
        // const data = await apiGet(`https://localhost:44313/api/heatmap/getall?projectId=${projectId}&startDate=${dateFrom.format("DD MMM YYYY HH:mm")}&endDate=${dateTo.format("DD MMM YYYY HH:mm")}&streamIds=${streamIds.join(',')}`);
        const data = await apiGet(`${API_URI}/api/heatmap/getall?projectId=${projectId}&startDate=${dateFrom.format("DD MMM YYYY HH:mm")}&endDate=${dateTo.format("DD MMM YYYY HH:mm")}&streamIds=${streamIds.join(',')}`);
        return data;
    },
    getAllSentiment: async (projectId: number, dateFrom: Moment, dateTo: Moment, streamIds: number[]) => {
        // const data = await apiGet(`https://localhost:44313/api/heatmap/getall?projectId=${projectId}&startDate=${dateFrom.format("DD MMM YYYY HH:mm")}&endDate=${dateTo.format("DD MMM YYYY HH:mm")}&streamIds=${streamIds.join(',')}`);
        const data = await apiGet(`${API_URI}/api/heatmap/sentiment/getall?projectId=${projectId}&startDate=${dateFrom.format("DD MMM YYYY HH:mm")}&endDate=${dateTo.format("DD MMM YYYY HH:mm")}&streamIds=${streamIds.join(',')}`);
        return data;
    },
}

export default heatmap;